module.exports = __webpack_public_path__ + "img/asset-error.4e13fe5f.svg";